<ng-container *ngIf="notificationMessage !== null">
    <div    class="alert alert-primary" 
        [class.alert-danger]="severity===3" 
        [class.alert-success]="severity===1" 
        [class.alert-warning]="severity===2" 
        role="alert" 
        >
        <h4><strong> {{title}}</strong></h4> 
        <span class="close-icon" (click)="close()"></span>
        <hr>
        <div class="mb-2" [innerHtml]="message | safe : 'html'"></div>

        <div *ngIf="confirmation != null">
            <button class="btn btn-small btn-green me-2" (click)="onOkClick()">{{ confirmation.okText }}</button>
            <button class="btn btn-small btn-green" (click)="onCancelClick()">{{ confirmation.cancelText }}</button>
        </div>
    </div>
</ng-container>
